var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTh(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 74,
    height: 72,
    viewBox: "0 0 74 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.3457 9.00726C14.7739 13.7176 15.0272 18.5947 15.0272 23.3181C15.0272 29.0897 15.286 34.9614 14.7874 40.6956C13.9413 50.4259 14.8 59.9416 14.8 69.6581",
    stroke: "#B00487",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.85156 40.1277C3.90694 40.1277 6.08092 40.2243 8.03527 39.6229C9.97741 39.0253 12.63 39.4462 14.6733 39.4462C16.9188 39.4462 19.1185 39.2191 21.387 39.2191C23.1754 39.2191 24.8232 39.4462 26.6116 39.4462",
    stroke: "#B00487",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M34.9419 7.78058C34.9419 21.3278 35.1061 34.848 35.1061 48.394C35.1061 52.5822 34.7778 56.7449 34.7778 60.9226C34.7778 63.2633 34.6137 65.5941 34.6137 67.9347C34.6137 68.5641 34.6084 67.9682 34.6137 67.652C34.6289 66.7371 34.7778 65.8384 34.7778 64.9165C34.7778 62.2251 34.9419 59.5433 34.9419 56.8649C34.9419 54.058 35.0204 51.2253 35.9997 48.5672C37.5235 44.431 40.952 41.1213 45.3187 40.1509C49.4484 39.2332 54.2571 39.2248 58.048 41.391C59.1057 41.9954 60.1133 42.3566 60.7105 43.4882C61.3056 44.6157 62.0078 45.7069 62.6436 46.8073C63.46 48.2203 63.7829 49.8758 64.1573 51.4395C64.5969 53.2754 65.2734 55.1875 65.3062 57.0929C65.3786 61.2887 65.4703 65.4572 65.4703 69.6581",
    stroke: "#EE2B00",
    strokeWidth: 3,
    strokeLinecap: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTh);
export default __webpack_public_path__ + "static/media/TH.b288e822f709f76ee164403eb5487453.svg";
export { ForwardRef as ReactComponent };